export default __webpack_public_path__ + "static/media/grafema_the-creativity-virus_07.93a1176a.jpg";